import { ESdChangeReason, IAction, IWorkFlow } from "@kuika/kuika-cl-model";
import { ILinkedProcessMappingInfo } from "@kuika/kuika-cl-model/src/models/workflow";
import { Guid } from "guid-typescript";
import { withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { withContext } from "../../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import KuikaSelectbox from "../../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { ActionPicker } from "../../properties-panel/action-picker";

export interface IWorkFlowLinkedprocessPropertiesState {
  // isExternalProcess: boolean | undefined;
  // actionToTriggerLinkedProcess: IAction | undefined;
  outputParametersOfLinkedProcess: any[];
}

export interface IWorkFlowLinkedprocessPropertiesProps {
  selectedNodeId: string | undefined;
}

class WorkFlowLinkedprocessProperties extends PureSdComponent<
  IWorkFlowLinkedprocessPropertiesProps,
  IWorkFlowLinkedprocessPropertiesState
> {
  constructor(props) {
    super(props);
    const selectedStep = this.props.sd.getSelectedWfStep();
    if (selectedStep?.actions?.length == 0) {
      const newAction = this.createAction();
      if (newAction) {
        selectedStep.actions = [newAction];
      }
    }
    this.state = {
      outputParametersOfLinkedProcess: []
    };
  }

  createAction = () => {
    const actionDefinitions = this.props.sd.actionDefinitions;
    let newAction: IAction | null = null;

    const startProcessDef = actionDefinitions.find((ad) => ad.name === "StartProcess");
    if (startProcessDef) {
      newAction = {
        id: Guid.create().toString(),
        actionDefinitionId: startProcessDef.id,
        label: startProcessDef.name,
        description: startProcessDef.name,
        parameters: startProcessDef.actionParameters.map((x) => this.cloneActionParameter(x)),
        returnType: startProcessDef.returnTypeName,
        returnCardinality: startProcessDef.returnCardinality
      } as IAction;
    }
    return newAction;
  };

  cloneActionParameter = (actionParameter: any) => {
    return {
      ...actionParameter,
      symbol: undefined
    };
  };

  setMappingForProcessOutput = (e: any, processOutputParameterId: string) => {
    const mapping = {
      linkedProcessOutputParameter: processOutputParameterId,
      callerProcessOutputParameter: e
    } as ILinkedProcessMappingInfo;
    const wf = this.props.sd.selectedWf;
    if (!wf) return;
    const selectedStep = this.props.sd.findStepRecursively(wf!, (s) => s.id === this.props.selectedNodeId!);
    if (!selectedStep) return;

    if (
      selectedStep.linkedProcess?.linkedProcessMappings?.some(
        (m) => m.linkedProcessOutputParameter == processOutputParameterId
      )
    ) {
      const existingMapping = selectedStep.linkedProcess?.linkedProcessMappings?.find(
        (m) => m.linkedProcessOutputParameter == processOutputParameterId
      );
      if (existingMapping) {
        existingMapping.callerProcessOutputParameter = e;
      }
    } else {
      if (!selectedStep.linkedProcess) {
        selectedStep.linkedProcess = {
          linkedProcessId: undefined,
          linkedProcessMappings: [] as ILinkedProcessMappingInfo[]
        };
      }
      selectedStep.linkedProcess.linkedProcessMappings.push(mapping);
    }
    this.props.sd.saveWorkFlow(wf, ESdChangeReason.WFStepMappingChange);
  };

  renderOutputMapping = () => {
    const selectedStep = this.props.sd.getSelectedWfStep();
    if (!selectedStep) return <></>;

    const actionToTriggerLinkedProcess = selectedStep.actions?.[0];
    if (!actionToTriggerLinkedProcess) return <></>;

    let processToTrigger: IWorkFlow | undefined;

    const projectId = actionToTriggerLinkedProcess.parameters.find((p) => p.name === "projectId")?.symbol?.fixedValue;
    const processId = actionToTriggerLinkedProcess.parameters.find((p) => p.name === "workflow")?.symbol?.fixedValue;

    if (selectedStep.linkedProcess) selectedStep.linkedProcess.linkedProcessId = processId;

    if (projectId === undefined || projectId === this.props.sd.project.id) {
      processToTrigger = this.props.sd.workFlowList.find((p) => p.id === processId) as IWorkFlow;
    } else {
      processToTrigger = this.props.sd.projectsWithWFData
        .find((p) => p.id === projectId)
        ?.workflows.find((w) => w.id === processId) as IWorkFlow;
    }

    const outputParametersOfLinkedProcess = processToTrigger?.parameters?.filter((p) => p.isOutput === true);
    if (!outputParametersOfLinkedProcess) return <>Linked process has no output parameters</>;

    return outputParametersOfLinkedProcess.map((p) => {
      return (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {this.props.sd.getTypeIcon(p.dataType.toString())}
            <span className="kuika_workflow-properties__text">{p.name}</span>
            <span className="kuika_workflow-properties__text" style={{ color: "var(--dark-6)" }}>
              ({p.dataType.toString()})
            </span>
          </div>

          <div
            className="kuika_styling_typography_wrapper kuika_screen-input__wrapper"
            style={{ borderBottom: "var(--border)" }}
          >
            <KuikaSelectbox
              allowClear
              placeholder="Not Used"
              value={
                selectedStep.linkedProcess?.linkedProcessMappings?.find((m) => m.linkedProcessOutputParameter == p.id)
                  ?.callerProcessOutputParameter
              }
              options={this.props.sd.selectedWf?.parameters
                ?.filter((prm) => prm.dataType === p.dataType)
                .map((prm) => ({
                  label: prm.name,
                  value: prm.id
                }))}
              onClear={() => {
                this.setMappingForProcessOutput("", p.id);
              }}
              onChange={(e) => {
                this.setMappingForProcessOutput(e, p.id);
              }}
            />
          </div>
        </div>
      );
    });
  };

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.SaveWorkflow ||
      changeReason === ESdChangeReason.ClickWfDesignXmlNode ||
      changeReason === ESdChangeReason.WFStepMappingChange ||
      changeReason === ESdChangeReason.DiActionUpdated
    ) {
      return true;
    }
    return false;
  };

  render() {
    const wf: IWorkFlow | undefined = this.props.sd.selectedWf;
    // const { isExternalProcess } = this.state;

    if (wf) {
      return (
        <div className="kuika__workflow__properties">
          <div className="kuika_workflow-properties__section">
            <ActionPicker preventAddAction={true} preventActionRemoval={true} />
          </div>

          <div className="kuika_workflow-properties__section">
            <div className="kuika-process-step-form">
              <span className="kuika_workflow-properties__property-type">Linked Process Output Mapping</span>
              {this.renderOutputMapping()}
            </div>
          </div>
        </div>
      );
    }
    return <></>;
  }
}

const WorkflowLinkedprocessProperties = withContext<IWorkFlowLinkedprocessPropertiesProps>(
  withSD<IWorkFlowLinkedprocessPropertiesProps>(WorkFlowLinkedprocessProperties)
);
export { WorkflowLinkedprocessProperties as WorkflowLinkedProcessProperties };
